module.exports = __webpack_public_path__ + "static/img/search_small@3x.2a4bdaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/search_small@3x.png
// module id = cFch
// module chunks = 10